import { __rest, __assign } from 'tslib';
import React from 'react';
import { TagDesktop } from '../../../../tag/esm/desktop';
import { SecondaryTabList } from './Component.js';
import { c as commonStyles } from '../../index.module-12c01850.js';
import 'classnames';
import '../../../../skeleton/esm';
import '../../hooks/use-tabs.js';
import 'react-merge-refs';
import '../../../../shared/esm';
import '../scrollable-container/Component.js';
import 'compute-scroll-into-view';
import '../scroll-controls/Component.js';
import 'lodash/debounce';
import '../../../../icon-button/esm';
import '@alfalab/icons-glyph/ChevronLeftCompactSIcon';
import '@alfalab/icons-glyph/ChevronRightCompactSIcon';
import '../scroll-controls/utils.js';

var SecondaryTabListDesktop = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 's' : _b, restProps = __rest(_a, ["size"]);
    return (React.createElement(SecondaryTabList, __assign({}, restProps, { TagComponent: TagDesktop, size: size, styles: commonStyles, tagSize: size, platform: 'desktop' })));
};

export { SecondaryTabListDesktop };
